import React from 'react';
import { Trophy } from 'lucide-react';

const Header = () => (
  <header className="flex flex-col items-center mb-8 pt-4">
    <div className="bg-emerald-500 p-3 rounded-2xl mb-3 shadow-lg shadow-emerald-500/20 rotate-3">
      <Trophy className="w-8 h-8 text-slate-900" />
    </div>
    <h1 className="text-3xl font-black tracking-tight text-white uppercase italic text-center">Pool<span className="text-emerald-500">Draw</span></h1>
    <div className="h-1 w-12 bg-emerald-500 rounded-full mt-1"></div>
  </header>
);

export default Header;
